module.exports = __webpack_public_path__ + "static/media/novotel-4.1d11d992.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/partner-hotels/novotel/novotel-4.jpg
// module id = 711
// module chunks = 6